import { render, staticRenderFns } from "./CollegeView01.vue?vue&type=template&id=5398edf4&scoped=true&"
import script from "./CollegeView01.vue?vue&type=script&lang=js&"
export * from "./CollegeView01.vue?vue&type=script&lang=js&"
import style0 from "./CollegeView01.vue?vue&type=style&index=0&id=5398edf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5398edf4",
  null
  
)

export default component.exports